import React, { useState } from "react";
import Select from "react-select";
 import { getUserData } from "../../auth";
 import { Chip, Stack } from "@mui/material";
import { useCreateTransationMutation } from "../../apis/TransationApi";
import { useNavigate } from "react-router-dom";
 
const SelectorComponent = ({balance,order }) => {
 
   const [isLoadingCreate, setIsLoadingCreate] = useState(false); // Track loading state
  const navigate = useNavigate();

  const userData = getUserData();
  const userId = userData?.uid || "";
  // RTK Query mutation hook for modifying the wallet request
  const [proceedTransaction,{isSuccess}] = useCreateTransationMutation();
  const totalPrice = Number(order?.cart?.totalPrice || 0);

   
 

  // Handle submit (using RTK Query mutation to modify the wallet request)
  const handleSubmit = async (e) => {
    e.preventDefault();

 

    setIsLoadingCreate(true); // Set loading state to true when submitting

    // Create wallet request object to send
    const totalPrice = Number(order.cart.totalPrice) || 0;
    const commissionRate = Number(order.items[0].commissionRate) || 0;
  
    //
    const transactionProcessing = {

      orderNumber:order?.cart?.orderNumber,
      paymentMethod:'', // Use current date for the request
      transactionAmount:totalPrice, 
      earnedPlusCapitalAmount: totalPrice * (commissionRate / 100),
      createdAt: new Date(), // Use current date for the request, 
      depositAt: "", // Example date, replace with actual logic if needed
      month: new Date().toLocaleString("default", { month: "long" }), // Get the current month as a string (e.g., "January")
      year: new Date().getFullYear().toString(), // Get the current year as a string
      active: true, 
    };

    try {
      // Call the RTK Query mutation to modify the wallet request
 await proceedTransaction({
  transaction: transactionProcessing, // Pass the transactionProcessing data
    order_id: order?.cart.id, // Assuming this is how the ID should be passed
    user_id: userId, // Assuming userId is the ID of the user
  }).unwrap();
  
   //   console.log("Request sent successfully:", transactionProcessing);
    } catch (error) {
      console.error("Failed to modify wallet request:", error);
    } finally {
      setIsLoadingCreate(false); // Reset loading state after request is finished

      // Redirect to /orders and reload the page
      navigate('/vendor-orders')
      window.location.reload();
    }
  }; 

  return (
    <>
         <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
          <form onSubmit={handleSubmit}>
            {/* commission */}
            <div className="mb-5">
            <Stack spacing={2} direction="column">
            <Chip label={`My Commission Rate: ${order?.items[0].commissionRate}%`} />
           </Stack>
            </div>
             {/* info */}

            <div className="mb-24">
            <Stack spacing={2} direction="column">
            <Chip label={`My Balance: ${balance}`} />
            <Chip label={`Order Payment: ${order?.cart.totalPrice}`} />
            <Chip label={`New Balance: ${Number(balance) - Number(order?.cart.totalPrice)}`} variant="outlined" />
          </Stack>
            </div>

            {/* Submit Button */}
            <div className="mt-24">
              <button
                type="submit"
                className="btn btn-main py-18 px-32 rounded-8"
                disabled={isLoadingCreate || (Number(balance) - Number(order?.cart.totalPrice))<0} // Disable button when loading or totalPrice < balance
                >
                {isLoadingCreate ? 'Processing...' : 'Process order'}
              </button>
            {/* Show success message */}
              {isSuccess && <p className="text-green-500 mt-4">Order well Processed! </p>}
            </div>
          </form>
        </div>
     </>
  );
};

export default SelectorComponent;
